import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// Define a service using a base URL and expected endpoints
export const jsonBinApi = createApi({
  reducerPath: 'jsonBinApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://api.jsonbin.io/v3/b/',
    prepareHeaders: (headers) => {
      headers.set(
        'X-Master-Key',
        '$2b$10$vi6aLwPJEIWgqE4COt23Nu1riTjz8FDj7rwVaSnWBIDScSvc4AJrS',
      );
      return headers;
    },
  }),
  //   tagTypes: ['Point', 'Node', 'Edge'],
  endpoints: (build) => ({
    getCounties: build.query({
      // this is the URL to counties json
      query: () => '6286963b402a5b38020388d5/latest',
      transformResponse: (response) => response.record,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetCountiesQuery } = jsonBinApi;
